export default __webpack_public_path__ + "6e3424d2e06250ec33fd47595e0304e4.svg";